import { lazy } from 'react'

export const ManteinanceDashboard = lazy(
  () => import(/* webpackChunkName: "soc" */ './Dashboard/Dashboard')
)

export const AllManteinances = lazy(
  () =>
    import(/* webpackChunkName: "soc" */ './AllManteinances/AllManteinances')
)

export const PreventiveByDate = lazy(
  () =>
    import(/* webpackChunkName: "soc" */ './PreventiveByDate/PreventiveByDate')
)

export const SingleManteinance = lazy(
  () =>
    import(
      /* webpackChunkName: "soc" */ './SingleManteinance/SingleManteinance'
    )
)
